import { Logo } from "./Logo";

export function Footer({ title = "" }) {
  return (
    <footer>
      <a href="https://heredesign.com" target="_blank" rel="noreferrer">
        <Logo />
      </a>
    </footer>
  );
}
